import React from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import { connect } from 'react-redux'
import ImageGallery from 'react-image-gallery'
import Divider from 'material-ui/Divider'
import Col from 'muicss/lib/react/col'
import Row from 'muicss/lib/react/row'
import "react-image-gallery/styles/css/image-gallery.css"
import './styles.css'
import { buyPrize } from '../../../actions'

const styles = {
  dialog:{
  },
  description:{
    fontWeight: 'bold',
    color: '#F58A15',
  },
  sliderWrapper:{
    width: '80%',
    margin: 'auto',
    height: '300px',
  },
  image:{
    height: '300px',
    objectFit: 'contain',
  },
  amount:{
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#F58A15',
  },
}

class PrizeDialog extends React.Component {

  handleClose = () => {
    this.props.toggleOpen()
  }

  


  render() {
    const buy = this.props.buy(this.props)
    const { name, image_url, images, description, credits, user_credits, amount } = this.props
    /*eslint-disable */
    const parsedImages = (images !== undefined ? images.map(image => {original: image}) : [{original: image_url}])
    const actions = [
      <FlatButton
        label="Cancelar"
        
        onTouchTap={this.handleClose}
      />,
      user_credits > credits ? 
        <FlatButton
          label={`Comprar por ${(credits||0).toLocaleString()} créditos`}
          primary
          onTouchTap={buy}
        />
        :
        <FlatButton
          label={`No tienes suficientes créditos`}
          primary
          disabled
        />
      ,
    ]

    return (
      <Dialog
        title={`${name} - ${(credits||0).toLocaleString()} créditos`}
        modal={true}
        actions={actions}
        open={this.props.open}
        onRequestClose={this.handleClose}
      >
        <div style={styles.dialog}>
          <div style={styles.sliderWrapper}>
            <ImageGallery
              items={parsedImages}
              slideInterval={1000}
              showNav={false}
              showThumbnails={false}
              useBrowserFullscreen={false}
              showPlayButton={false}
              showBullets={true}
              showFullscreenButton={false}
              />
          <br/>
          <Row>
            <Col xs='12' style={styles.amount}>Quedan {(amount||0).toLocaleString()} unidades</Col>
          </Row>
          </div>
          <div style={styles.description}>DESCRIPCIÓN</div>
          <Divider inset={false} />
          <br/>
          <div dangerouslySetInnerHTML={{ __html: description||(`Producto sin descripción.`) }}></div>
          <br/>
        </div>
      </Dialog>
    )
  }

}

PrizeDialog.propTypes = {
  open: React.PropTypes.bool.isRequired,
  toggleOpen: React.PropTypes.func.isRequired,
}

const mapStateToProps = state => ({ ...state.user.global_prizes.prize_selected,
  user_credits: state.user.credits,
 })

const mapDispatchToProps = dispatch => ({
  buy: props => () => {
    props.toggleOpen()
    dispatch(buyPrize(props))

  },
})


export default connect(mapStateToProps, mapDispatchToProps)(PrizeDialog)



// WEBPACK FOOTER //
// ./src/components/Main/PrizeDialog/index.jsx